import React, { useEffect, useState, useCallback } from "react";
import List from "../farmList";
import Filter from "../farmFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import { useNavigate } from "react-router-dom";
import {
  Header,
  HeaderTop,
  HeaderIcon,
  HeaderContent,
  Title,
  Subtitle,
  NewSessionButton,
  PageContainer,
} from "./../../course/courseList/courseList.styled";

const queryClient = new QueryClient();

const FarmFilterListContainer = (props) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState(undefined);

  const navigate = useNavigate();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.center.title") },
  ];

  const loadData = useCallback(async () => {}, []);

  useEffect(() => {
    loadData();
  }, []);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  // const handlerFilterOwner = async (value) => {
  //   let filter = {
  //     filters: {
  //       name: value,
  //     },
  //   };
  //   let result = await UserServices.filterAllUser(filter);
  //   if (result && result.length === 0) {
  //     if (filters?.ownerUuid) {
  //       filter = {
  //         filters: {
  //           uuid: filters.ownerUuid,
  //         },
  //       };
  //       result = await UserServices.filterAllUser(filter);
  //     }
  //   }
  //   return result;
  // };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  return (
    <>
      <PageContainer>
        <Header>
          <HeaderTop>
            <HeaderIcon>
              <i className="fas fa-book"></i>
            </HeaderIcon>
            <HeaderContent>
              <Title>{t("forms.center.title")}</Title>
              <Subtitle>{t("forms.course.subtitle")}</Subtitle>
            </HeaderContent>
          </HeaderTop>

          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            // onFilterOwner={handlerFilterOwner}
            // onFilterTecnical={handlerFilterTecnical}
          />
        </Header>

        <Header>
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </Header>
      </PageContainer>
    </>
  );
};

FarmFilterListContainer.propTypes = {};

export default FarmFilterListContainer;
